import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

function ConfirmarEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [estado, setEstado] = useState('carregando'); // carregando | erro
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    if (!token) { setEstado('erro'); setMensagem('Link de confirmação inválido.'); return; }
    // A confirmação só libera o login; o usuário entra com a própria senha
    api.post('/cadastro-publico/confirmar-email', { token })
      .then(res => {
        navigate('/login', {
          replace: true,
          state: { sucesso: res.data?.mensagem || 'E-mail confirmado! Faça login com seu e-mail e senha.' },
        });
      })
      .catch(err => {
        setEstado('erro');
        setMensagem(err.response?.data?.mensagem || 'Erro ao confirmar e-mail.');
      });
  }, [token, navigate]);

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: '#1e40af', margin: 0 }}>CronoObra</h1>

        {estado === 'carregando' && (
          <p style={{ fontSize: 14, color: '#6b7280', marginTop: 24 }}>Confirmando seu e-mail...</p>
        )}

        {estado === 'erro' && (
          <>
            <div style={{ fontSize: 48, margin: '20px 0 12px' }}>⚠️</div>
            <p style={{ fontSize: 14, color: '#dc2626', marginBottom: 20 }}>{mensagem}</p>
            <button className="btn-secondary" style={{ width: '100%' }} onClick={() => navigate('/login')}>
              Ir para o login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default ConfirmarEmail;
